const mutations = {
  getToken(state, val) {   		//登录权限
    
    state.token = val;
    return state.token;
    
  },
  getInformation(state,val){
    console.log(state,val,"getInformation方法")
    return state.information=val
  }
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js